import { unitMapping } from '@sorare/core/src/lib/style';

type Props = {
  size?: keyof typeof unitMapping;
  className?: string;
};

export const Jersey = ({ size = 2, className }: Props) => {
  return (
    <svg
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.64311 4.45686L1.51654 1.33029L0 2.5002L1.46667 4.0002L2.33333 3.36686V7.12889H4.99967H7.66667V3.36686L8.53333 4.0002L10 2.5002L8.4836 1.3304L5.35714 4.45686L5.00012 4.81388L4.64311 4.45686ZM7.66667 8.13868H4.99967H2.33333V9.23353H7.66667V8.13868ZM2.33333 0.700195L2.3227 0.708395L5.00012 3.38581L7.67744 0.708503L7.66667 0.700195H6.2L5 1.9002L3.8 0.700195H2.33333Z"
        fill="currentColor"
      />
    </svg>
  );
};
